import { useRouter } from "next/router";
import React, { PropsWithChildren } from "react";
import { useAppContext } from "@kunduz/feature-website-context";
import { AuthEvents, serializeProfiles } from "@kunduz/feature-onboarding";
import { useFirebaseAuth } from "@kunduz/feature-firebase";
import { calculateUrl } from "@kunduz/utility-next-link";
import { AUTH_PAGEURLS } from "@kunduz/utility-common";
import { useLocalStorage } from "react-storage-complete";

/**
 * wrap social login buttons with this component to trigger auth logics
 */
const SocialAuthButtonProvider = (props: PropsWithChildren<Props>) => {
  const [kunduzApiToken, setKunduzApiToken] =
    useLocalStorage<string>("kunduzApiToken");
  const [kunduzApiRole, setKunduzApiRole] =
    useLocalStorage<string>("kunduzApiRole");
  const { localeInfo, toast } = useAppContext();
  const router = useRouter();
  const { setProviderName, signInWithGoogle, signInWithApple } =
    useFirebaseAuth();
  const returnUrl = calculateUrl({
    href: router.asPath,
    query: router.query,
  });

  function onClick(e) {
    e.preventDefault();

    switch (props.type) {
      case "google":
        // trackEvent("Authentication Button Clicked", {
        //   button_location: props.location,
        //   authentication_type: "Google",
        //   country: localeInfo.selectedCountry?.country_name,
        //   country_code: localeInfo.selectedCountry?.code,
        // });
        AuthEvents.googleAuthButtonClicked({
          component: props.location,
          label: props.label,
        });
        startGoogleSignin();
        break;
      case "apple":
        // trackEvent("Authentication Button Clicked", {
        //   button_location: props.location,
        //   authentication_type: "Apple",
        //   country: localeInfo.selectedCountry?.country_name,
        //   country_code: localeInfo.selectedCountry?.code,
        // });

        AuthEvents.appleAuthButtonClicked({
          component: props.location,
          label: props.label,
        });
        startAppleSignin();
        break;
      default:
        break;
    }
  }

  /**
   * logic for clicking google sign in modal
   */
  async function startGoogleSignin() {
    try {
      // trigger firebase auth modal
      const otpResponse = await signInWithGoogle();
      setProviderName("google");

      // if we have auth token, set and return;
      if (otpResponse.auth_token) {
        setKunduzApiToken(otpResponse.auth_token);
        // Save serialized profiles to storage
        const profiles = serializeProfiles(otpResponse.profiles);
        setKunduzApiRole(profiles);
        // trackEventForSocialLoggedin(otpResponse.auth_token, "google");
        return;
      }
      // if we dont, redirect to account type switch page
      else {
        window.location =
          `${AUTH_PAGEURLS.B2C_REGISTER_STUDENT_INFO}?returnUrl=${returnUrl}` as any;
      }
    } catch (error) {
      toast.toastError(error.message);
    }
  }

  /**
   * logic for clicking apple sign in modal
   */
  async function startAppleSignin() {
    try {
      // trigger firebase auth modal
      const otpResponse = await signInWithApple();
      setProviderName("apple");

      // if we have auth token, set and return;
      if (otpResponse.auth_token) {
        setKunduzApiToken(otpResponse.auth_token);
        // Save serialized profiles to storage
        const profiles = serializeProfiles(otpResponse.profiles);
        setKunduzApiRole(profiles);
        // trackEventForSocialLoggedin(otpResponse.auth_token, "apple");
        return;
      }
      // if we dont, redirect to account type switch page
      else {
        window.location =
          `${AUTH_PAGEURLS.B2C_REGISTER_STUDENT_INFO}?returnUrl=${returnUrl}` as any;
      }
    } catch (error) {
      toast.toastError(error.message);
    }
  }

  return React.cloneElement(props.children as any, { onClick });
};

interface Props {
  type: "google" | "apple";
  location: string;
  label?: string;
}

export default SocialAuthButtonProvider;
